import {
  TableRow,
  TableCell
} from '@mui/material';

import { useAuthStore } from '../stores/useAuthStore';
import { useTripStatusAnalysis } from '../hooks/analysis/useTripStatusAnalysis';
import { usePontos } from '../hooks/pontos/usePontos';
import { useTripPositionsAnalysis } from '../hooks/analysis/useTripPositionsAnalysis';
import { buildTripTableData } from '../utils/export/buildTripTableData';

const TripTableRow = ({ trip }) => {
  
  const perfisDisponiveis = useAuthStore(state => state.perfisDisponiveis);

  const tripStatus = useTripStatusAnalysis(
    trip?.DATA_REFERENCIA,
    trip?.CODIGO_INTEGRACAO,
    trip?.DATAHORA_FINAL_PREVISTO
  );

  const pontos = usePontos(trip?.CODIGO_INTEGRACAO);
  const positionsAnalysis = useTripPositionsAnalysis(trip?.DATA_REFERENCIA, trip?.CODIGO_INTEGRACAO);
  
  const rowData =
    buildTripTableData({
      trip,
      tripStatus,
      pontos,
      positionsAnalysis,
      motorista: null,
      kmTotalRota: 0,
      ultimaOcorrencia: null,
      ultimaTrocaVeic: null,
      turnoNome: null,
      perfisDisponiveis
    });

  return (
    <TableRow hover>

      <TableCell align='center'
        sx={(theme) => ({
            borderLeft: 6,
            borderLeftColor:
                rowData.barColor &&
                theme.palette[rowData.barColor]
                    ? theme.palette[rowData.barColor].main
                    : theme.palette.divider,
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8
        })}
      >
        {rowData.Linha}
      </TableCell>

      <TableCell align='center'>
        {rowData.Sentido}
      </TableCell>

      <TableCell align='center'>
        {rowData.Cliente}
      </TableCell>

      <TableCell align='center'>
        {rowData['Prefixo']} - {rowData['Placa']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Unidade Operacional']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Código de Integração']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Pontos Atendidos']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Progresso']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Início Previsto']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Início Real']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Final Previsto']}
      </TableCell>

      <TableCell align='center'>
        {rowData['Final Real']}
      </TableCell>

       <TableCell align='center'
        sx={(theme) => ({
          whiteSpace: 'pre-line',
          lineHeight: 1,
          backgroundColor:
            theme.palette[rowData.barColor]?.main,
          color: theme.palette.getContrastText(
            theme.palette[rowData.barColor]?.main
          ),
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8
        })}
      >
        {rowData.situacao}
        {rowData.detalheSituacao && (
          <>
            {'\n'}
            {rowData.detalheSituacao}
          </>
        )}
      </TableCell>

    </TableRow>
  );

};

export default TripTableRow;